import { FileTypeEnum } from 'utils'

import { Paths } from '../types'

export enum FinderTabsEnum {
  unsplash = 'unsplash',
}

export interface IFinderFilePickerProps {
  paths?: Paths
  params: {
    companyId: string
    projectId?: string
    fileMetaGroupId?: string
  }
  defaultContentType?: FileTypeEnum
  tabs?: FinderTabsEnum[]
  onFilePick: (fileId: string) => void
  checkbox?: boolean
}
